import PropTypes from "prop-types";
import TextOverflowFade from "../../TextOverflowFade";
import styles from "./index.css";

export const ProductDescription = ({ text }) => (
  <div aria-hidden={true} className={styles.productDescription}>
    <TextOverflowFade text={text} ElementType="h2" />
  </div>
);

ProductDescription.propTypes = {
  text: PropTypes.string.isRequired
};

export default ProductDescription;
